module.exports = __webpack_public_path__ + "img/70200.180b2db5.jpg";